module.exports = __webpack_public_path__ + "static/risk-test-1-7ec9c86445bc5f47eb57576e2954d5f4.svg";